import { render, staticRenderFns } from "./input-shortcut.vue?vue&type=template&id=d4678ab6&scoped=true"
import script from "./input-shortcut.vue?vue&type=script&lang=js"
export * from "./input-shortcut.vue?vue&type=script&lang=js"
import style0 from "./input-shortcut.vue?vue&type=style&index=0&id=d4678ab6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4678ab6",
  null
  
)

export default component.exports